Ext.define('SA.view.sidebar.data.Condition', {
    alias: 'widget.condition',
    extend: 'Ext.Component',

    cls: 'sa-condition',

    tpl: [
        '<span aria-label="remove condition" class="sa-condition-remove-button" role="button">',
            '<svg aria-hidden="true"><use href="#sa-icon-close"></use></svg>',
        '</span>',
        '<span class="sa-condition-label">“{text:htmlEncode}”</span>'
    ],

    clear() {
        this.setText('');
    },

    getText() {
        return this.text;
    },

    initEvents() {
        this.callParent();

        this.el.on('click', this.onRemoveClick, this, {delegate: '.sa-condition-remove-button'});
    },

    notEmpty() {
        return !!this.text;
    },

    onRemoveClick() {
        this.fireEvent('click:remove');
    },

    setText(text) {
        this.text = text = text.trim();

        this.update({text});
        this.setVisible(!!text);
    }
});
